import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  glass?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(({ className, glass, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn('rounded-xl border border-primary/20 bg-card/50 p-4', glass && 'backdrop-blur-xs', className)}
      {...props}
    />
  );
});
Card.displayName = 'Card';
